export default __webpack_public_path__ + "static/media/Sample - Original.7911b383.png";